import React from 'react';

export default function Impact() {
  return (
    <section id="impact" className="py-24 bg-slate-900 text-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <div>
            <h2 className="text-3xl md:text-5xl font-bold mb-8">Delivering Real Business Impact</h2>
            <p className="text-lg text-slate-300 mb-12 leading-relaxed">
              Our managed transport services don't just move people; they move your business forward by optimizing costs and improving employee satisfaction.
            </p>
            
            <div className="grid grid-cols-2 gap-8">
              {[
                { value: "10%", label: "Cost Reduction", sub: "via route optimization" },
                { value: "98%", label: "On-Time Arrivals", sub: "consistent performance" },
                { value: "4.8/5", label: "Employee CSAT", sub: "average rating" },
                { value: "100%", label: "Compliance", sub: "statutory adherence" },
              ].map((stat, idx) => (
                <div key={idx} className="border-l-4 border-secondary pl-6">
                  <div className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.value}</div>
                  <div className="font-bold text-lg text-secondary mb-1">{stat.label}</div>
                  <div className="text-sm text-slate-400">{stat.sub}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-secondary to-teal-600 rounded-3xl transform rotate-3 opacity-20 blur-lg"></div>
            <div className="relative bg-slate-800 p-8 md:p-12 rounded-3xl border border-slate-700">
              <h3 className="text-2xl font-bold mb-6">Client Success Story</h3>
              <blockquote className="text-xl text-slate-300 italic mb-8">
                "Switching to WorkRidePro transformed our employee transport. We saved 25% on logistics costs in the first year while seeing a massive jump in employee satisfaction scores due to the app's reliability."
              </blockquote>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-slate-600 flex items-center justify-center font-bold text-xl">
                  JD
                </div>
                <div>
                  <div className="font-bold">John Doe</div>
                  <div className="text-sm text-slate-400">Facilities Head, TechGiant Inc.</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
